<template>
  <div class="knowledge-class-overview" >

    <div class="overview-head">
      <div class="overview-head__num">02</div>
      <div class="overview-head__title">班级概览</div>
    </div>

    <div class="overview-title">
      <div class="class-content">
        <div class="class-content__left">
          <p class="left-line"/>
          <p class="left-text">
            <span class="text-bg">各班级掌握程度</span>
          </p>
        </div>
        <div id="classChart" style=""/>
      </div>
      <div class="class-ranking">
        <div class="class-ranking__right">
          <p class="left-line"/>
          <p class="left-text">
            <span class="text-bg">班级排名</span>
          </p>
        </div>
        <div class="overview-list">
          <div class="overview-list__title">
            <p class="title-grade">班级</p>
            <p class="title-grasp">平均掌握程度</p>
          </div>
          <ul class="overview-list__item">
            <li class="item-content" v-for="(item,index) in overviewData"
            :key="`overview_${index}`" @click="queryDetail(item)">
              <div :class="index<3?'item-content__num':'item-content__default'">{{index+1}}</div>
              <div class="item-content__class">{{item.class_name}}</div>
              <div class="item-content__percentage"
              :class="getRightClass(item.score)">{{item.score}}%</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KnowledgeClassOverview',
  props: {
    overviewData: {
      type: Array,
      default: () => [],
    },
    rankingAvgScore: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      chart: '',
      mockList: [],
    };
  },
  watch: {
    overviewData(v) {
      this.$nextTick(() => {
        this.initChart(v);
      });
    },
  },
  methods: {
    // 掌握程度颜色区分
    getRightClass(value) {
      if (value === -1) {
        return 'default';
      }
      if (value >= 70) {
        return 'level2';
      }
      if (value >= 40) {
        return 'level1';
      }
      return 'level3';
    },
    // 跳转到普通班级报告
    queryDetail(item) {
      const { schoolId } = this.$route.query;
      this.$router.push({
        path: 'class-report',
        query: {
          schoolId,
          evaluateId: item.evaluate_id,
          classId: item.class_id,
          batchId: item.batch_id,
        },
      });
    },
    initChart(data) {
      this.chart = this.$echarts.init(document.getElementById('classChart'));
      const chartName = data.map((item) => item.class_name);
      const chartVal = data.map((item) => item.score);

      const option = {
        color: '#1890FF',
        grid: {
          left: '50',
          right: '120',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisLabel: { interval: 0, rotate: 30 },
          data: chartName,
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: '{value} %',
            },
            show: true,
            max: 100,
            min: 0,
          },
        ],
        series: [{
          markLine: {
            symbol: 'none',
            data: [{
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: { // 警戒线的样式  ，虚实  颜色
                type: 'dotted',
                color: this.rankingAvgScore > 0 ? '#F56C6C' : 'rgba(0, 0, 0, 0)',
              },
              label: {
                show: this.rankingAvgScore > 0,
                position: 'end',
                color: '#F56C6C',
                formatter: `班级均线 : ${this.rankingAvgScore}%`,
              },
              yAxis: this.rankingAvgScore,
            }],
          },
          type: 'bar',
          label: {
            normal: {
              show: true,
              position: 'top',
              formatter: '{c}%',
            },
          },
          data: chartVal,
          barWidth: '15%',
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter(params) {
            // 暂时不要header
            // const headerName = params.length && `<div style="text-align:center;">
            // ${params[0].name}</div>`;
            const customList = params.length && params.map((item) => {
              const dotColor = `<span style="display:inline-block;margin-right:5px;border-radius:
            10px;width:9px;height:9px;background-color:${item.color}"></span>`;
              return `${dotColor + item.name}:${item.value || 0}%</br>`;
            });
            // return headerName + customList.join('');
            return customList.join('');
          },
        },
      };
      this.chart.setOption(option);
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
.knowledge-class-overview{
  .overview-head{
    display: flex;
    padding:45px 0 0 19px;
    align-items: center;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      line-height: 29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
  }
  .overview-title{
    display: flex;
    justify-content: space-between;
    padding:0 20px;
    .class-content{
      display:flex;
      flex-direction:column;
      width:70%;
      &__left{
        display: flex;
        align-items: center;
        width: 100%;
      }
    }
    .class-ranking{
      display:flex;
      flex-direction:column;
      width:30%;
      &__right{
        display: flex;
        align-items: center;
      }
    }
    .overview-list{
      height:420px;
      overflow-y: auto;
      &__title{
        display:flex;
        align-items: center;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(48, 49, 51, 0.4);
        .title-grade{
          width:50%;
          text-align: center;
        }
        .title-grasp{
          width:50%;
          text-align: center;
        }
      }
      &__item{
        margin-top:12px;
        .item-content{
          display: flex;
          align-items: center;
          margin-top:20px;
          cursor: pointer;
          &__num{
            width: 24px;
            height: 24px;
            background: #1890FF;
            color:#ffffff;
            border-radius: 50%;
            text-align: center;
            line-height: 24px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
          &__default{
            width: 24px;
            height: 24px;
            background: #EAEAEA;
            color:rgba(17, 31, 44, 0.4);;
            border-radius: 50%;
            text-align: center;
            line-height: 24px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
          &__class{
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(17, 31, 44, 0.6);
            margin-left:40px;
            width:59%;
          }
          &__percentage{
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
        }
      }
    }
  }
  .overview-content{
    display: flex;
    .overview-chart{
      flex:6.9;
      position: relative;
      .chart-scope{
        width: 100%;
        height:500px;
      }
      .split-line{
        position: absolute;
        bottom:67px;
        width:85%;
        left:50px;
        height:2px;
        border-bottom:2px dashed #F56C6C;
      }
      .split-content{
        position: absolute;
        width: 200px;
        height: 30px;
        top:180px;
        left:230px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #F56C6C;
      }
    }
  }
}
.left-line{
  margin:19px 0 20px 0;
  display: block;
  width: 3px;
  height: 16px;
  background: #1890FF;
  border-radius: 3px;
  margin-right: 8px;
}
.left-text{
  font-size: 18px;
  height: 25px;
  font-family: 'PingFangSC-Medium', 'PingFang SC';
  font-weight: 500;
  color: #000000;
  line-height: 25px;
  position: relative;
  &:after{
    content:'';
    position: absolute;
    width:100%;
    height:50%;
    left:0;
    bottom:3px;
    background:rgba(230, 162, 60, 0.2);
    border-radius: 16px;
  }
  .text-bg{
    position: relative;
    z-index: 2;
  }
}
#classChart{
  width:100%;
  height:500px;
}
</style>
